import styled from 'styled-components';
import { darkgrey, grey } from 'styles/Colors';

export const Wrapper = styled.div`
  font-family: Oswald;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  color: ${darkgrey};
  text-transform: uppercase;
  letter-spacing: 0.6px;
  display: flex;
  align-items: center;
`;

export const Versus = styled.span`
  font-size: 13px;
  color: ${grey};
  font-weight: 500;
  margin: 0 12px;
`;

export const TaggingInfo = styled.div`
  margin-top: 3px;
  font-size: 13px;
  line-height: 18px;
  color: ${grey};
`;

export const Circle = styled.div<{ backgroundColor: string }>`
  width: 12px;
  height: 12px;
  background-color: ${(props) => props.backgroundColor};
  border-radius: 50%;
  margin-right: 4px;
`;

export const TeamsWrapper = styled.div`
display: flex;
flex-direction: column;
`;